module.exports = __webpack_public_path__ + "static/media/prime-mover.76c65320.svg";